"use client";
import copy from "copy-to-clipboard";
import { useState } from "react";
import { Button, type ButtonVariantsType } from "@/components/ui/button";
import { ElementType } from "@/constants/tagular/main";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import { ElementClicked } from "@/hooks/eventing/types/redventures.usertracking.v3.ElementClicked";

const containerClass = {
  lg: "p-1",
  sm: "p-0.5",
};

const buttonClass = {
  lg: "",
  sm: "text-xs px-4 py-1",
};

export default function CopyButton({
  text,
  buttonVariant = "brand",
  size = "lg",
  location,
  htmlId,
}: {
  text: string;
  buttonVariant?: ButtonVariantsType;
  size?: "lg" | "sm";
  location?: string;
  htmlId?: string;
}) {
  const [copied, setCopied] = useState(false);

  const webElement: ElementClicked["webElement"] = {
    location,
    position: "1",
    elementType: ElementType.Button,
    htmlId,
    text,
    name: "copy-text",
  };

  const { elementClicked } = useElementEvents({
    webElement,
  });

  const handleClick = () => {
    copy(text);
    setCopied(true);
    elementClicked();
  };

  return (
    <div
      className={`flex items-center rounded-md bg-white border-2 border-primary w-fit ${containerClass[size]}`}
    >
      <span className="pl-4 pr-2">{text}</span>
      <Button
        variant={buttonVariant}
        onClick={handleClick}
        className={`font-bold text-xs ${buttonClass[size]}`}
      >
        {copied ? "COPIED" : "COPY"}
      </Button>
    </div>
  );
}
